"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = exports.btnTypes = exports.btnSizes = exports.BaseButton = void 0;

var _react = _interopRequireDefault(require("react"));

var ST = _interopRequireWildcard(require("./styled"));

var _excluded = ["type", "size", "text", "price", "iconsSprite", "symbolId", "href", "className", "isLoading", "disabled", "isRotatedIcon", "onClick", "children", "buttonWidth", "buttonHeight", "block"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var btnTypes = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  GREY: 'grey',
  STRETCH: 'stretch',
  LINK: 'link'
};
exports.btnTypes = btnTypes;
var btnSizes = {
  LARGE: 'large',
  MIDDLE: 'middle',
  SMALL: 'small'
};
exports.btnSizes = btnSizes;
var sizes = {
  large: {
    vPadding: 15,
    hPadding: 24,
    iconPadding: 12,
    fontSize: 16,
    lineHeight: 24,
    iconSize: 24
  },
  middle: {
    vPadding: 8,
    hPadding: 24,
    iconPadding: 8,
    fontSize: 16,
    lineHeight: 24,
    iconSize: 24
  },
  small: {
    vPadding: 8,
    hPadding: 16,
    iconPadding: 8,
    fontSize: 14,
    lineHeight: 20,
    iconSize: 20
  }
};
exports.sizes = sizes;

var BaseButton = function BaseButton(_ref) {
  var _sizes$size, _sizes$size2;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'primary' : _ref$type,
      size = _ref.size,
      text = _ref.text,
      price = _ref.price,
      iconsSprite = _ref.iconsSprite,
      symbolId = _ref.symbolId,
      href = _ref.href,
      className = _ref.className,
      isLoading = _ref.isLoading,
      disabled = _ref.disabled,
      isRotatedIcon = _ref.isRotatedIcon,
      onClick = _ref.onClick,
      children = _ref.children,
      buttonWidth = _ref.buttonWidth,
      buttonHeight = _ref.buttonHeight,
      block = _ref.block,
      rest = _objectWithoutProperties(_ref, _excluded);

  var elementType = href ? 'a' : 'button';
  var isOnlyIcon = symbolId && !text && !children;
  return /*#__PURE__*/_react["default"].createElement(ST.Button, _extends({
    as: elementType,
    type: type,
    size: size,
    href: href,
    className: className,
    isLoading: isLoading,
    disabled: disabled,
    onClick: disabled || isLoading ? function () {
      return null;
    } : onClick,
    isOnlyIcon: isOnlyIcon,
    buttonWidth: buttonWidth,
    buttonHeight: buttonHeight,
    block: block
  }, rest), iconsSprite && symbolId && /*#__PURE__*/_react["default"].createElement(ST.IconWrap, {
    isOnlyIcon: isOnlyIcon,
    isRotatedIcon: isRotatedIcon,
    size: size
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: ((_sizes$size = sizes[size]) === null || _sizes$size === void 0 ? void 0 : _sizes$size.iconSize) || '24',
    height: ((_sizes$size2 = sizes[size]) === null || _sizes$size2 === void 0 ? void 0 : _sizes$size2.iconSize) || '24'
  }, /*#__PURE__*/_react["default"].createElement("use", {
    href: "".concat(iconsSprite, "#").concat(symbolId)
  }))), /*#__PURE__*/_react["default"].createElement(ST.Inner, {
    isPrice: !!price
  }, children ? children : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, text), price && /*#__PURE__*/_react["default"].createElement("span", null, price))));
};

exports.BaseButton = BaseButton;